<div class="new-claim-modal container">
  <div class="row">
    <div class="form-check new-claim-modal__content new-claim-modal__content col-12">
      <div class="cx-dialog-header modal-header">
        <div class="cx-dialog-title modal-title">
          <h3>{{ dispenserTypeEnum[dispenserType] }}</h3>
        </div>
        <button
          type="button"
          class="close"
          aria-label="Close"
          cxModal="dismiss"
          cxModalReason="Cross click"
          (click)="dismissModal()"
        >
          <span aria-hidden="true">
            <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
          </span>
        </button>
      </div>

      <div class="cx-dialog-body modal-body">
        <div class="cx-dialog-row">
          <div [innerHTML]="typeDetails"></div>
        </div>
      </div>
    </div>
  </div>
</div>
